import { createVNode as _createVNode, createTextVNode as _createTextVNode, createStaticVNode as _createStaticVNode, openBlock as _openBlock, createBlock as _createBlock } from "vue"
import _imports_0 from '@/assets/image/logo-white.png'


const _hoisted_1 = { class: "header" }
const _hoisted_2 = /*#__PURE__*/_createVNode("img", {
  alt: "",
  class: "logo",
  src: _imports_0
}, null, -1)
const _hoisted_3 = { class: "menu" }
const _hoisted_4 = /*#__PURE__*/_createStaticVNode("<div class=\"menu-item\"> 创作者服务 <ul class=\"popover\"><li><a href=\"https://mcn.mgtv.com/index\" target=\"_blank\">MCN机构</a></li><li><a href=\"https://creator.mgtv.com\" target=\"_blank\">个人创作者</a></li></ul></div><div class=\"menu-item\"><a href=\"https://xiaomang.mgtv.com\" target=\"_blank\">商家入驻</a></div><div class=\"menu-item\"><a href=\"http://open.shopmang.com\" target=\"_blank\">开放平台</a></div>", 3)
const _hoisted_7 = /*#__PURE__*/_createVNode("div", { class: "menu-item" }, [
  /*#__PURE__*/_createTextVNode(" 加入我们 "),
  /*#__PURE__*/_createVNode("ul", { class: "popover" }, [
    /*#__PURE__*/_createVNode("li", null, [
      /*#__PURE__*/_createVNode("a", {
        href: "https://app.mokahr.com/m/apply/xiaomang-mgtv/42363",
        target: "_blank"
      }, "社会招聘")
    ]),
    /*#__PURE__*/_createVNode("li", null, [
      /*#__PURE__*/_createVNode("a", {
        href: "https://app.mokahr.com/m/campus-recruitment/xiaomang-mgtv/42364",
        target: "_blank"
      }, "实习生招聘")
    ])
  ])
], -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _hoisted_2,
    _createVNode("div", _hoisted_3, [
      _createVNode("div", {
        onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.router.push({ name: 'Home' }))),
        class: ['menu-item', _ctx.route.name === 'Home' ? 'active ' : '']
      }, "首页", 2),
      _hoisted_4,
      _createVNode("div", {
        onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.router.push({ name: 'About' }))),
        class: ['menu-item', _ctx.route.name === 'About' ? 'active ' : '']
      }, "关于我们", 2),
      _hoisted_7
    ])
  ]))
}